import { Matrix4, Vector2Tuple, Vector3 } from 'three';

import {
  DecorationNode,
  FCompositionNode,
  FNode,
  FNodeTypesEnum,
  FurnitureNode,
} from '../types/index.js';

const _vertex = new Vector3();
const _mat4 = new Matrix4();

export const outlineFromNode = (node: FNode): Vector2Tuple[] => {
  let outline: Vector2Tuple[] = [];

  if (
    node.type === FNodeTypesEnum.FComposition ||
    node.type === FNodeTypesEnum.Furniture ||
    node.type === FNodeTypesEnum.Decoration
  ) {
    const cNode = node as FCompositionNode | FurnitureNode | DecorationNode;
    if (!cNode.outline2D) {
      cNode.computeOutline2D();
    }
    outline = (cNode.outline2D?.array as Vector2Tuple[]).map((p) => {
      _vertex.set(p[0], 0, p[1]);
      _vertex
        .applyMatrix4(_mat4.makeRotationY(cNode.rotation))
        .applyMatrix4(_mat4.makeTranslation(node.position[0], 0, node.position[1]));
      return [_vertex.x, _vertex.z];
    });
  }

  return outline;
};
